var _rect, _line, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "black",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.95312,
    width: 18.3691,
    height: 15.9456,
    rx: 4.25,
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.583984,
    y1: 6.46875,
    x2: 19.2843,
    y2: 6.46875,
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.65869,
    width: 1.5528,
    height: 3.72975,
    rx: 0.776398,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.457,
    width: 1.5528,
    height: 3.72975,
    rx: 0.776398,
    fill: "current"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9209,
    y: 11.4299,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.01172,
    y: 11.4299,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.01172,
    y: 14.4382,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.104,
    y: 14.4382,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1948,
    y: 14.4382,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.104,
    y: 11.4299,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1948,
    y: 11.4299,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.01172,
    y: 8.42188,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11.104,
    y: 8.42188,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9209,
    y: 14.4382,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1948,
    y: 8.42188,
    width: 1.75316,
    height: 1.80472,
    rx: 0.876578,
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.01b559b07ca12eae091fd17defbd2c05.svg";
export { ForwardRef as ReactComponent };